import { fbFunctions } from "@/config/firebase";

export default {
    data: function() {
        return {
            cancelSuspensionClicked: false,
        }
    },
    methods: {

        /**
         * Cancel user's suspension
         * If everything is okay we route the user to the dashboard
         * Else we show him a warning message
         */
        cancelSuspension() {
            let vm = this;
            let cancelUserSuspension = fbFunctions.httpsCallable('api');

            if (this.cancelSuspensionClicked) return;
            this.cancelSuspensionClicked = true;
            Swal.fire(
                this.$t("administration.suspended.cancel_in_progress_title"),
                this.$t("administration.suspended.cancel_in_progress_subtitle"),
                "warning"
            );
            cancelUserSuspension({
                type: 'userSuspendOrUnsuspendAccount',
                parameters: {}
            })
            .then(function(result) {
                if(result.data === "SUCCESS_ACCOUNT_UNSUSPENDED") {
                    swal.fire(
                        vm.$t("administration.suspended.canceled_suspension_successfully_title"),
                        vm.$t("administration.suspended.canceled_suspension_successfully_subtitle"),
                        "success"
                    )
                    vm.$router.push('/dashboard')
                }
                else {
                    swal.fire(
                        vm.$t("administration.suspended.canceled_suspension_error_title"),
                        vm.$t("administration.suspended.canceled_suspension_error_subtitle"),
                        "error"
                    )
                }
            })
            .catch((e) => {
                swal.fire(
                    vm.$t("administration.suspended.canceled_suspension_error_title"),
                    vm.$t("administration.suspended.canceled_suspension_error_subtitle"),
                    "error"
                )
            });
        },

    }
};


// WEBPACK FOOTER //
// ./src/pages/administration/suspended/master/suspended.js